<template>
  <div class="ui form">
    <h5 class="ui dividing header">
      {{ $t('updateEmail') }}
    </h5>
    <div class="field">
      <label for="current">{{ $t('email') }}:</label>
      <div class="ui input left icon">
        <i class="at icon"></i>
        <input type="email"
               :placeholder="$t('email')"
               v-model="email"
               name="email">
      </div>
    </div>
    <div class="ui submit button right floated" @click="updateEmail()" :class="{disabled: isPressed}">
      {{ $t('update') }}
    </div>
    <br>
    <br>
    <!-- <div class="ui divider"></div> -->

    <h5 class="ui dividing header">
      {{ $t('updatePassword') }}
    </h5>
    <div class="field">
      <label for="current">{{ $t('currentPassword') }}:</label>
      <div class="ui fluid input left icon">
        <i class="lock icon"></i>
        <input type="password"
               v-model="password.current"
               :placeholder="$t('currentPassword')" />
      </div>
    </div>

    <div class="field">
      <label for="new">{{ $t('newPassword') }}: </label>
      <div class="ui fluid input left icon">
        <i class="lock icon"></i>
        <input v-model="password.new"
               type="password"
               :placeholder="$t('newPassword')" />
      </div>
    </div>

    <div class="field">
      <label for="confirmation">{{ $t('passwordConfirmation') }}: </label>
      <div class="ui fluid input left icon">
        <i class="lock icon"></i>
        <input v-model="password.confirmation"
               type="password"
               :placeholder="$t('passwordConfirmation')" />
      </div>
    </div>

    <div class="ui submit button right floated" @click="updatePassword()" :class="{disabled: isPressed}">
      {{ $t('update') }}
      </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      password: {
        current: null,
        new: null,
        confirmation: null
      },
      email: null,
      isPressed: false
    }
  },
  methods: {
    updatePassword () {
      this.$http.post(`users/${this.$auth.user().id}/update/password`, this.password).then(response => {
        this.password = {
          current: null,
          new: null,
          confirmation: null
        }
        this.logout()
      })
    },
    updateEmail () {
      this.$http.post(`users/${this.$auth.user().id}/update/email`, { email: this.email })
        .then(response => {
          this.email = null
          this.logout()
        })
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/users/users_components/UpdateAuthentication.vue